import type z from "zod";

import { zSchema } from "../../../../entity";

const zIn = zSchema.pick({
  id: true,
});
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
